import React from 'react'
import { useState, useMemo, useEffect, useRef } from 'react'
import { Select as SelectTea, ConfigProvider } from 'tea-component'
// import en_US from "tea-component/es/i18n/locale/en_US";

import SelectButton from '@/pages/dashboard/components/SelectButton'

import './index.scss'
import { Props } from './types'

const Select = (props: Props) => {
  const {
    value,
    defaultValue,
    label = '',
    className,
    options = [],
    onChange,
    boxStyle = {},
    buttonContentClassName,
  } = props
  const bindClassName = useRef(label?.replace(/\s/g, '') + Date.now().toString(36))
  const defaultValueInner = options?.[0]?.value ?? ''
  const [selectValue, setSelectValue] = useState(value ?? defaultValue ?? defaultValueInner)
  const valueList = options?.filter(item => selectValue === item.value)?.map(item => item.text) as string[]

  const selectOptions = useMemo(() => {
    return options.map?.((item) => {
      return ({
        ...item,
        text: (
          <p className='select-item'>
            {item.icon && <img className='select-item-icon' src={item.icon} /> }
            <span className='select-item-text'>{item.text}</span>
          </p>
        )
      })
    })
  }, [options])

  const handleChange = (value: any) => {
    onChange?.(value)
    setSelectValue(value)
  }

  useEffect(() => {
    if (!value) return
    setSelectValue(value)
  }, [value])

  return (
    <>
      <SelectTea
        // matchButtonWidth={true}
        className={`${bindClassName.current} ${className}`}
        appearance='button'
        boxClassName='select-container'
        boxStyle={boxStyle}
        button={<SelectButton label={label} selectList={valueList} contentClassName={buttonContentClassName}/>}
        value={selectValue}
        defaultValue={selectValue}
        onChange={handleChange}
        options={selectOptions}
        closeOnScroll={false}
        positionFixed={false}
        popupContainer={ () => document.querySelector(`.${bindClassName.current}`)}
        overlayClassName={"select-container__overlay"}
      />
    </>
  )
}

export default Select
